<template>
  <div v-clickaway="onClickaway" :class="$options.name">
    <input
      v-model="query"
      type="text"
      class="input-lg input-white"
      placeholder="Поиск места и адреса"
      @input="debouncedFetch($event.target.value)"
      @keypress.enter="onEnterPressed"
      @click="active = true"
    >

    <div class="search-icon">
      <transition name="fade">
        <!--        <icon v-if="!isLoading" :size="22" name="magnify" />-->
        <!--        <spinner v-else color="#fff" />-->
      </transition>
    </div>

    <div v-if="suggestions && suggestions.length && active" class="search-container">
      <ul class="reset-ul search__list">
        <li
          v-for="item in suggestions"
          :key="item.place_id"
          class="search__list-item"
          @click="onSuggestionClick(item)"
        >
          <a href="#">
            {{ item.display_name }}
            <span>
              {{ regionText(item) }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { directive as clickaway } from 'vue-clickaway';
import debounce from 'lodash/debounce';
// import Spinner from '@/components/Spinner';
import CIRCLE_POINT from '@/core/layers/styles/index';
import http from '@/utils/api';

const LAYER_ID = 'search-point';

export default {
  name: 'geocoder',
  // components: { Spinner },
  directives: { clickaway },
  props: {
    map: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    query: null,
    isLoading: false,
    lastQuery: null,
    objectFutures: null,
    active: false,
    suggestions: [],
  }),
  created() {
    const debouncedFetch = debounce(this.onSearch, 800);

    this.debouncedFetch = (...args) => {
      this.objectFutures = null;
      this.isLoading = true;
      debouncedFetch(...args);
    };
  },

  methods: {
    async onSearch(query) {
      this.lastQuery = query;

      if (!query) {
        this.removePointLayer();
        this.objectFutures = null;
        this.isLoading = false;
        this.suggestions = [];
        return;
      }

      try {
        this.isLoading = true;
        this.suggestions = await http.get(`geocoder/search?query=${query}`);
        this.active = true;
      } finally {
        this.isLoading = false;
      }

      if (this.lastQuery !== query) {
        this.onSearch(this.lastQuery);
      }
    },

    onSuggestionClick(item) {
      let zoom = 11;
      switch (item.class) {
        case 'place':
          zoom = 7;
          break;
        case 'building':
        case 'office':
          zoom = 17;
          break;
        case 'natural':
          zoom = 14;
          break;
        default:
          zoom = 11;
          break;
      }

      if (item.geometry) {
        const geometry = typeof item.geometry === 'string'
          ? JSON.parse(item.geometry)
          : item.geometry;

        this.addGeometryOnMap(geometry.coordinates, zoom);
      } else {
        this.addGeometryOnMap([item.lon, item.lat], zoom);
      }
    },

    addGeometryOnMap(coordinates, zoom) {
      this.$emit('add-marker-on-map', coordinates);
      this.addPointLayer(coordinates);
      this.map.flyTo({ center: coordinates, zoom });
    },

    addPointLayer(coordinates) {
      const source = {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates,
          },
        },
      };
      const pointLayer = CIRCLE_POINT(LAYER_ID, source, { radius: 4 });
      this.removePointLayer();
      this.map.addLayer(pointLayer);
    },

    removePointLayer() {
      if (this.map.getLayer(LAYER_ID)) this.map.removeLayer(LAYER_ID);
      if (this.map.getSource(LAYER_ID)) this.map.removeSource(LAYER_ID);
    },

    onEnterPressed() {},

    onClickaway() {
      this.active = false;
    },

    regionText(item) {
      const result = [];
      if (!item.address) return '';

      const { address } = item;

      if (address.country) {
        result.push(address.country);
      }

      if (address.region) {
        result.push(address.region);
      }

      if (address.state) {
        result.push(address.state);
      }

      return result.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
  .geocoder {
    position: absolute;
    width: 300px;
    height: 30px;
    left: 10px;
    top: 10px;
    z-index: 10;

    input {
      width: 100%;
      height: 100%;
      background: white;
      padding: 16px 10px;
      border: 2px solid #ccc;
      border-radius: 6px;

      &:focus {
        border: 2px solid #778eff;
        box-shadow: none;
        outline: none;
      }
    }
  }

  .search-container {
    height: 300px;
    overflow-y: scroll;
    background: #fff;

    .search {
      &__list {
        list-style: none;
        margin: 0;
        padding: 0;
        position: relative;
        &-item {
          & + .search__list-item {
            border-top: 1px solid #ccc;
          }

          font-size: 14px;
          line-height: 1.4;

          &:first-of-type {
            border-top-right-radius: 3px;
            border-top-left-radius: 3px;

            a:hover {
              border-top-right-radius: 3px;
              border-top-left-radius: 3px;
            }
          }

          &:last-of-type {
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;

            a:hover {
              border-bottom-left-radius: 3px;
              border-bottom-right-radius: 3px;
            }
          }

          a {
            text-decoration: none;
            display: block;
            color: #000;
            font-weight: 500;
            padding: 16px !important;

            &:hover {
              color: #778eff;
              background: #f3f3f3;
              border-color: #3c4450;

              span {
                color: #5067e3;
              }
            }
          }

          span {
            display: block;
            margin-top: 4px;
            font-size: 11px;
            line-height: 1.4;
            color: #393939;
            transition: 0.3s;
          }
        }
      }
    }
  }
</style>
